import { Button } from "@mui/material";
import React, { useState } from "react";
import QuestionImportExcelModal from "resources/question/view/components/modals/QuestionImportExcelModal";

const ImportQuestionsButton = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <Button onClick={handleOpenModal} size='small'>Импорт</Button>
      <QuestionImportExcelModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  )
}

export default ImportQuestionsButton
